// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FranchisorChannels_TriggerSaveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * FranchisorChannels_TriggerSaveInput — body for POST /franchisor-channels/trigger-save.
 *
 * `id` null = create a new binding; a positive int = update an existing one.
 * The controller layers FOUR named refusals on top of this input's own
 * validation (docs/billing-franchisor-channels.md):
 *   - 'trigger_unknown'            — trigger_key not in FranchisorTriggerCatalog
 *   - 'trigger_not_implemented'    — enabled:true on a catalog implemented:false trigger
 *   - 'channel_type_already_bound' — Franchisor_channel_triggers_model::saveBinding()'s
 *                                    at-most-one-enabled-per-(trigger x channel type) rule
 *   - 'unknown_template_var:<name>' — the bound template references a
 *                                    {{var}} outside the trigger's allowed-vars list
 *                                    (TemplateRenderer::listUnknownVars)
 */
import { registerContract } from './validate'

export interface FranchisorChannels_TriggerSaveInput {
trigger_key: string
channel_id: number
template_id: number
id?: number
recipient_groups?: string[]
enabled?: boolean
}

registerContract('FranchisorChannels_TriggerSaveInput', {
  trigger_key:      { type: 'string',  required: true },
  channel_id:       { type: 'number',  required: true },
  template_id:      { type: 'number',  required: true },
  id:               { type: 'number',  required: false },
  recipient_groups: { type: 'array',   required: false },
  enabled:          { type: 'boolean', required: false },
})
